import { createElement } from "../util/ui/Element";
import { toLocaleAwareUpperCase } from "../util/String";
import { translitLang } from "../SystemState";
import { setupToggle } from "./Togglable";
import { logEvent } from "../util/Analytics";
import { saveItem } from "../util/LocalStorage";
import { getKeysAndTransliterations } from "./KeyboardLayoutUtil";
export default class KeyboardLayout {
    constructor(isHidden, onKeyPressed) {
        this.shouldCreateLayout = false;
        this.keysContainer = document.getElementById("keyboardKeys");
        this.onKeyPressed = onKeyPressed;
        translitLang.observe(this.updateLanguage.bind(this));
        if (isHidden)
            this.shouldCreateLayout = true;
        else
            this.createLayout();
        setupToggle(this.keysContainer, "keyboard__hide", strings.showKeyboard, strings.hideKeyboard, isHidden, this.onToggled.bind(this));
    }
    get isHidden() {
        return this.keysContainer.classList.contains("-hidden");
    }
    updateLanguage() {
        if (this.isHidden) {
            this.shouldCreateLayout = true;
            return;
        }
        this.keysContainer.textContent = "";
        this.createLayout();
    }
    onToggled(isHidden) {
        saveItem("keyboardHidden", isHidden);
        logEvent("keyboard_toggled", { isHidden: isHidden });
        if (this.shouldCreateLayout) {
            this.keysContainer.textContent = "";
            this.createLayout();
        }
    }
    createLayout() {
        const lang = translitLang.value;
        getKeysAndTransliterations(lang).forEach(letter => {
            const item = createElement("div", "keyboard__item", this.keysContainer);
            const transliterations = createElement("div", "keyboard__transliteration", item);
            const key = createElement("button", "keyboard__key", item);
            transliterations.textContent = letter.transliterations;
            key.textContent = letter.key;
            key.onclick = e => this.onKeyPressed(e.shiftKey ? toLocaleAwareUpperCase(letter.key, lang) : letter.key);
        });
    }
}
